import { render, staticRenderFns } from "./AddCounterForm.vue?vue&type=template&id=4c2db21b&scoped=true&"
import script from "./AddCounterForm.vue?vue&type=script&lang=js&"
export * from "./AddCounterForm.vue?vue&type=script&lang=js&"
import style0 from "./AddCounterForm.vue?vue&type=style&index=0&id=4c2db21b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2db21b",
  null
  
)

export default component.exports